import { useEffect } from 'react';

export default function useScrollObserver(setActiveId) 
{
    useEffect(() => 
    {
        const headers = document.querySelectorAll(
            'article h2[id]:not([id=""])'
        );
        const observer = new IntersectionObserver(
            (entries) => 
            {
                entries.forEach((entry) => 
                {
                    if (entry.isIntersecting) 
                    {
                        setActiveId(entry.target.id);
                    }
                });
            },
            {
                rootMargin: '-20% 0px -60% 0px',
                threshold: 0.1,
            }
        );

        headers.forEach((h2) => observer.observe(h2));

        return () => 
        {
            headers.forEach((header) => 
            {
                observer.unobserve(header);
            });
        };
    }, [setActiveId]);
}
